import React from 'react';
import styled from 'styled-components';

import TabPanel from './components/TabPanel';

interface ITab {
  tabValue: string;
  label: string;
  isVisible?: boolean;
}

interface IRootProps {
  isSmallMode?: boolean;
  children?: React.ReactNode;
}

interface ITabsProps {
  tabs: ITab[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  children?: React.ReactNode;
  defaultTab: string;
  isSmallMode?: boolean;
}

interface ITabButtonProps {
  isActive: boolean;
  isSmallMode: boolean;
}

const Tabs: React.FC<ITabsProps> = (props) => {
  const { tabs, activeTab, onTabChange, children, isSmallMode = false } = props;

  return (
    <Root isSmallMode={isSmallMode}>
      <Header>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.tabValue;
          if (tab?.isVisible === false) {
            return null;
          }
          return (
            <TabButton
              key={tab.tabValue}
              onClick={() => onTabChange(tab.tabValue)}
              isActive={isActive}
              isSmallMode={isSmallMode}
            >
              <TabPanel  tabValue={tab.tabValue} activeTab={activeTab}>
                {tab.label}
              </TabPanel>
            </TabButton>
          );
        })}
      </Header>
      <div>{children}</div>
    </Root>
  );
};

export default Tabs;

const Root = styled.div<IRootProps>`
  font-family: Raleway;
  font-style: normal;
  font-weight: 700;
  font-size: ${({ isSmallMode }) => (isSmallMode ? '16px' : '20px')};
  line-height: ${({ isSmallMode }) => (isSmallMode ? '18px' : '22px')};

  @media (max-width: 540px) {
    font-size: 16px;
    line-height: 18px;
  }
`;

const Header = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

const TabButton = styled.button<ITabButtonProps>`
  padding: 0px 16px 16px 16px;
  cursor: pointer;
  border: none;
  background: none;
  border-bottom: ${({ isActive }) => isActive ? '3px solid #FF7E55' : '3px solid transparent'};
  color: ${({ isActive }) => isActive ? '#FFFFFF' : '#696969'};
  transition: all 0.3s ease;

  @media (max-width: 540px) {
  padding: 0px 8px 12px 8px;
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  border-bottom: ${({ isActive }) =>
    isActive ? '2px solid #FF7E55' : '2px solid transparent'};
  }
`;
